<p>
  {{message}}
</p>

@if (authenticationEjbErrorPage) {
  <div>
    <p><b>iRebal is currently unavailable.</b></p>
    <p>We're working on the issue, and will have iRebal available again soon!<br/>
      We apologize for any inconvenience this may cause, and thank you for your understanding.<br/>
      If you have any questions, please contact your FSA or iRebal support team to correct your user configuration at 855-640-2472.<br/>
    </p>
  </div>
}
